import { render, staticRenderFns } from "./UserRequestComponent.vue?vue&type=template&id=efdf8296&scoped=true"
import script from "./UserRequestComponent.vue?vue&type=script&lang=js"
export * from "./UserRequestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efdf8296",
  null
  
)

export default component.exports